import React from 'react'
import './Projectcard.css'

function WriteCard(props) {
    return (
      <>
      <div className='container'>
        <div className='carda'>
            <div className='titlebox'>
                <h1 className='titlecard'>{props.title}</h1>
                <p className='publication'>{props.tech}</p>
                <p className='description'>{props.desc}</p>
                <a href={props.link} target="_blank" className="buttona">Go To Project</a>
            </div>
        </div>
      </div>
  
      
      </>
    )
  }
  
  export default WriteCard